import { render } from "./SettingsHome.vue?vue&type=template&id=ce7f7978&scoped=true"
import script from "./SettingsHome.vue?vue&type=script&lang=js"
export * from "./SettingsHome.vue?vue&type=script&lang=js"

import "./SettingsHome.vue?vue&type=style&index=0&id=ce7f7978&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce7f7978"]])

export default __exports__